import { render, staticRenderFns } from "./DateComparisonExpressionSelector.vue?vue&type=template&id=5a84518a&scoped=true&"
import script from "./DateComparisonExpressionSelector.vue?vue&type=script&lang=ts&"
export * from "./DateComparisonExpressionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DateComparisonExpressionSelector.vue?vue&type=style&index=0&id=5a84518a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84518a",
  null
  
)

export default component.exports